export enum ConnectionFirstContact {
  Message = 'Message',
  Package = 'Package',
  Quote = 'Quote',
}
